export const carPlanningValueModesEnum = {
    Plan: "plan",
    Fact: "fact",
    PlanAndFact: "planAndFact",
};

export const defaultCarPlanningValueMode = carPlanningValueModesEnum.Plan;

export const carPlanningValueModes = [
    { label: "Только плановые", shortLabel: "План", value: carPlanningValueModesEnum.Plan },
    { label: "Только фактические", shortLabel: "Факт", value: carPlanningValueModesEnum.Fact },
    { label: "Плановые и фактические", shortLabel: "План + факт", value: carPlanningValueModesEnum.PlanAndFact },
];

export const carPlanningSubgroups = {
    Plan: "plan",
    Draft: "draft",
    Fact: "fact",
    FactFallbackPlan: "factFallbackPlan",
    EmptyMileagePlan: "emptyMileagePlan",
    EmptyMileageFact: "emptyMileageFact",
    EmptyMileageFactFallbackPlan: "emptyMileageFactFallbackPlan",
    ServiceWork: "serviceWork",
    Marker: "marker",
};

export const normalizeCarPlanningValueMode = (valueMode) =>
    Object.values(carPlanningValueModesEnum).includes(valueMode) ? valueMode : defaultCarPlanningValueMode;

export const buildCarPlanningSubgroupVisibility = (valueMode, hideEmptyMileage) => {
    const selectedValueMode = normalizeCarPlanningValueMode(valueMode);
    const showEmptyMileage = !hideEmptyMileage;
    const baseVisibility = {
        [carPlanningSubgroups.Plan]: false,
        [carPlanningSubgroups.Draft]: false,
        [carPlanningSubgroups.Fact]: false,
        [carPlanningSubgroups.FactFallbackPlan]: false,
        [carPlanningSubgroups.EmptyMileagePlan]: false,
        [carPlanningSubgroups.EmptyMileageFact]: false,
        [carPlanningSubgroups.EmptyMileageFactFallbackPlan]: false,
        [carPlanningSubgroups.ServiceWork]: true,
        [carPlanningSubgroups.Marker]: true,
    };

    switch (selectedValueMode) {
        case carPlanningValueModesEnum.Fact:
            return {
                ...baseVisibility,
                [carPlanningSubgroups.Fact]: true,
                [carPlanningSubgroups.FactFallbackPlan]: true,
                [carPlanningSubgroups.EmptyMileageFact]: showEmptyMileage,
                [carPlanningSubgroups.EmptyMileageFactFallbackPlan]: showEmptyMileage,
            };
        case carPlanningValueModesEnum.PlanAndFact:
            return {
                ...baseVisibility,
                [carPlanningSubgroups.Plan]: true,
                [carPlanningSubgroups.Draft]: true,
                [carPlanningSubgroups.Fact]: true,
                [carPlanningSubgroups.EmptyMileagePlan]: showEmptyMileage,
                [carPlanningSubgroups.EmptyMileageFact]: showEmptyMileage,
            };
        case carPlanningValueModesEnum.Plan:
        default:
            return {
                ...baseVisibility,
                [carPlanningSubgroups.Plan]: true,
                [carPlanningSubgroups.Draft]: true,
                [carPlanningSubgroups.EmptyMileagePlan]: showEmptyMileage,
            };
    }
};
